import React, {Component} from 'react';
import { Icon } from 'react-fa';

class EditableDropdown extends Component {

  constructor(props){
    super(props);

    this.state = {
      hovering: false,
      editing: false,
      editValue: this.props.selectedValue
    }
  }

  toggleEditing(){
    this.setState({editing: !this.state.editing, hovering: false});
  }

  setNewValue() {
    this.setState({text: this.state.editValue, editing: false});
    this.props.readyFn(this.state.editValue);
  }

  updateEditValue(value){
    this.setState({editValue: value});
  }

  mouseEnter() {
    this.setState({hovering: true});
  }

  mouseLeave(){
    this.setState({hovering: false});
  }

  render(){

    const { items } = this.props;

    if(this.state.editing)
      return (
      <span>
        <select
          className="form-control EditableDropdown"
          onChange={(e) => this.updateEditValue(e.target.value)}
          value={this.state.editValue}
        >
        {items.map(item => <option key={item}>{item}</option>  )}
       </select>
        <button
            className="btn btn-primary"
            style={{marginRight:'6px', marginLeft:'10px', marginTop: '-3px'}}
            type="button"
            onClick={() => this.setNewValue()}
        >
          Listo
        </button>
        <button
            style={{marginTop: '-3px'}}
            className="btn btn-primary"
            type="button"
            onClick={() => this.toggleEditing()}
        >
          Cancelar
        </button>
      </span>
      );

    const cssClass = "btn btn-link" + (this.state.hovering ? " InputEditable" : " InputNormal");

    return(
    <span>
      <button
          className={cssClass}
          onClick={() => this.toggleEditing()}
          onMouseEnter={() => this.mouseEnter()}
          onMouseLeave={() => this.mouseLeave()}
       >
        {this.state.editValue}
        <Icon name="edit" size="lg" className="EditIcon" />
      </button>
    </span>
    );
  }

}

export default EditableDropdown;
